var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9162 9.69432V4.71368C16.9162 3.61501 16.4475 3.17554 15.2829 3.17554H12.3238C11.1592 3.17554 10.6904 3.61501 10.6904 4.71368V9.69432C10.6904 10.793 11.1592 11.2325 12.3238 11.2325H15.2829C16.4475 11.2325 16.9162 10.793 16.9162 9.69432Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2258 11.3057V16.2864C9.2258 17.385 8.75704 17.8245 7.59245 17.8245H4.63336C3.46877 17.8245 3 17.385 3 16.2864V11.3057C3 10.207 3.46877 9.76758 4.63336 9.76758H7.59245C8.75704 9.76758 9.2258 10.207 9.2258 11.3057Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9162 16.2864V14.2355C16.9162 13.1369 16.4475 12.6974 15.2829 12.6974H12.3238C11.1592 12.6974 10.6904 13.1369 10.6904 14.2355V16.2864C10.6904 17.3851 11.1592 17.8245 12.3238 17.8245H15.2829C16.4475 17.8245 16.9162 17.3851 16.9162 16.2864Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2258 6.76453V4.71368C9.2258 3.61501 8.75704 3.17554 7.59245 3.17554H4.63336C3.46877 3.17554 3 3.61501 3 4.71368V6.76453C3 7.8632 3.46877 8.30267 4.63336 8.30267H7.59245C8.75704 8.30267 9.2258 7.8632 9.2258 6.76453Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.63d47d1ada7773340267b7325073d9bb.svg";
export { ForwardRef as ReactComponent };